import React, { FC, useEffect, useState } from 'react';
import classes from './StartWithSetting.module.css';
import Filter from '../Filter';
import StartWithSettingFilter from '../StartWithSettingFilter';
import ProductCard from './ProductCard';
import { RootState } from '../../reducers/RootReducer';
import {
  setAfterDiamondSelectOptions,
  setFilterMinMaxProperty,
  setMaximumCaratSize,
  setOptionsByProduct,
  setResetStartWithSettingFilter,
  setSelectedProduct,
  setStartWithSettingFilter,
  setStartWithSettingFilterFail,
  setStartWithSettingFilterLoading,
  setStartWithSettingFilterSuccess,
  setStartWithSettingProductFail,
  setStartWithSettingProductLoading,
  setStartWithSettingProductSuccess,
  setSwatchColor
} from '../../action/StartWithSettingFilterAction';
import { setHeaderTabToStud } from "../../action/HeaderAction";
import { setDiamondDetailsFail, setDiamondDetailsLoading, setDiamondDetailsSuccess } from '../../action/DiamondAction';
import { setIsShowFooter } from '../../action/FooterAction';
import { connect, ConnectedProps } from 'react-redux';
import Loader from '../Loader/Loader';
import Icon from '../Icons/Icon';
import useStartWithSetting from './useStartWithSetting';
import { SetTooltipDataError, setTooltipDataLoading, SetTooltipDataSuccess } from '../../action/TooltipAction';
import { PropsFromScreenManager } from '../../types';
import Header from '../Header/Header';
import StickyFooter from '../StickyFooter/StickyFooter';
import { setExpandedRow } from '../../action/TableAction';
import {
  setRingOptions,
  setSelectedDiamondFail,
  setSelectedDiamondLoading,
  setSelectedRingDetails
} from '../../action/RingAction';
import { setFilter } from '../../action/FilterAction';
import NoDataFound from "../NoDataFound/NoDataFound";
import {
  toDiamondShapeSlug,
  toCenterDiamondTypeSlug,
  toMetalColorSlug,
  toCaratValue,
  toRingStyleValue
} from "../../constant/trackingContract";
import { FavouriteEntry, favouriteKey } from '../../Utils/favouriteProducts';
import { ReactComponent as Bookmark } from '../../Utils/images/Bookmark.svg';

const mapStateToProps = (state: RootState) => ({
  settingFilter: state.settingFilter,
  diamond:       state.diamond,
  tooltip:       state.tooltip,
  ring:          state.ring,
  table:         state.table,
  filter:        state.filter,
  footer:        state.footer
});

const mapDispatchToProps = {
  setStartWithSettingFilterLoading,
  setStartWithSettingFilterSuccess,
  setStartWithSettingFilterFail,
  setResetStartWithSettingFilter,
  setStartWithSettingProductLoading,
  setStartWithSettingProductSuccess,
  setStartWithSettingProductFail,
  setFilterMinMaxProperty,
  setDiamondDetailsLoading,
  setDiamondDetailsSuccess,
  setDiamondDetailsFail,
  setIsShowFooter,
  setTooltipDataLoading,
  SetTooltipDataSuccess,
  SetTooltipDataError,
  setAfterDiamondSelectOptions,
  setSwatchColor,
  setExpandedRow,
  setRingOptions,
  setSelectedRingDetails,
  setStartWithSettingFilter,
  setSelectedDiamondLoading,
  setSelectedDiamondFail,
  setFilter,
  setOptionsByProduct,
  setSelectedProduct,
  setMaximumCaratSize,
  setHeaderTabToStud,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromStartWithSettingRedux = ConnectedProps<typeof connector>;

const StartWithSetting: FC<
  PropsFromStartWithSettingRedux & PropsFromScreenManager
> = (props) => {
  const { instanceData, settingFilter, setHeaderTabToStud, diamond } = props;

  const {
    dropdownRef,
    sortBy,
    isDropdownOpen,
    options,
    selectedImages,
    handleSwatchClick,
    swatchLoadingIds,
    handleDropdownToggle,
    handleRESETFilters,
    handleOptionClick,
    handleClickOutside,
    swatches,
    isMobileLayout,
    showImageSlider,
    handleProduct,
    getProductHref,
    handleScrollTopClick,
    isLargeTablet,
    showButton,
    scrollRoot,
    createUniqueProductId,
    isStuds,
    isReset,
    favouriteProducts,
    favouriteEntries,
    favouriteImages,
    handleFavouriteSwatchClick,
    favouriteSwatchLoadingIds,
    toggleFavourite,
    isFavouriteTab,
    setIsFavouriteTab
  } = useStartWithSetting(props);
  const [ loadedImages, setLoadedImages ] = useState<Set<string>>(new Set());
  const [ isFavouritePanelOpen, setIsFavouritePanelOpen ] = useState(false);
  const hasFavourites = !isStuds && favouriteProducts.length > 0;
  const isFavouriteView = isFavouriteTab && hasFavourites;
  const visibleCount = isFavouriteView ? favouriteEntries.length : settingFilter.products.length;
  const handleImageLoad = (src?: string) => {
    if (!src) return;
    setLoadedImages((prev) => (prev.has(src) ? prev : new Set(prev).add(src)));
  };

  useEffect(() => {
    if (!hasFavourites || isMobileLayout) setIsFavouriteTab(false);
    if (!hasFavourites || !isMobileLayout) setIsFavouritePanelOpen(false);
  }, [ hasFavourites, isMobileLayout ]);

  const handleTabChange = (nextIsFavourite: boolean) => {
    setIsFavouriteTab(nextIsFavourite);
    scrollRoot.current?.scrollTo({ top: 0 });
  };

  const renderProductCard = (product: any, index: number) => {
    const uniqueProductId = createUniqueProductId(product);
    const swatch = selectedImages[uniqueProductId]?.swatch;
    const tileImageUrl = selectedImages[uniqueProductId]?.imagePath;
    const tileColor = toMetalColorSlug(selectedImages[uniqueProductId]?.swatch) || undefined;
    const tileDiamondShape = toDiamondShapeSlug(product.default_options?.Diamond_Shape) || undefined;
    const tileCenterDiamondType = toCenterDiamondTypeSlug(
      (settingFilter.options?.['Center_Diamond_Type'] as string)
      || (diamond?.details?.source as string)
      || 'LGN'
    ) || undefined;
    const tileRingStyle = toRingStyleValue(product.collections, product.ring_style) || undefined;
    const tracking = {
      settingId: product.Code,
      price: product.price_at,
      ringStyle: tileRingStyle,
      diamondShape: tileDiamondShape,
      centerDiamondType: tileCenterDiamondType,
      color: tileColor,
      imageUrl: tileImageUrl,
      payload: JSON.stringify({
        id: product.Code,
        name: product.Name,
        price: product.price_at,
        ...(tileRingStyle && { ringStyle: tileRingStyle }),
        ...(tileDiamondShape && { diamondShape: tileDiamondShape }),
        ...(tileColor && { color: tileColor }),
        ...(tileCenterDiamondType && { centerDiamondType: tileCenterDiamondType }),
        imageUrl: tileImageUrl,
      }),
    };
    return (
      <ProductCard
        key={`${index}_${uniqueProductId}`}
        product={product}
        uniqueProductId={uniqueProductId}
        isSelected={settingFilter.selectedProduct === product.Code}
        isStuds={isStuds}
        showImageSlider={showImageSlider}
        selectedImage={selectedImages[uniqueProductId]}
        swatches={swatches}
        swatchLoadingIds={swatchLoadingIds}
        loadedImages={loadedImages}
        tracking={tracking}
        href={getProductHref(product)}
        onImageLoad={handleImageLoad}
        onSelect={() => handleProduct(product.Code, product)}
        onSwatchClick={(key) => handleSwatchClick(uniqueProductId, product, key)}
        isFavourite={favouriteProducts.includes(favouriteKey(uniqueProductId, swatch))}
        onToggleFavourite={() => toggleFavourite(product, swatch)}
      />
    );
  };

  /* Card id is createUniqueProductId + swatch, which alone would collide across colours. */
  const renderFavouriteCard = (entry: FavouriteEntry, index: number) => {
    const cardId = favouriteKey(entry.id, entry.color);
    const image = favouriteImages[cardId];
    const tileImageUrl = image?.imagePath;
    const tileColor = toMetalColorSlug(image?.swatch) || undefined;
    const tileDiamondShape = toDiamondShapeSlug(entry?.product.default_options?.Diamond_Shape) || undefined;
    const tileCenterDiamondType = toCenterDiamondTypeSlug(
      (settingFilter.options?.['Center_Diamond_Type'] as string)
      || (diamond?.details?.source as string)
      || 'LGN'
    ) || undefined;
    const tileRingStyle = toRingStyleValue(entry?.product.collections, entry?.product.ring_style) || undefined;
    const tracking = {
      settingId: entry?.product.Code,
      price: entry?.product.price_at,
      ringStyle: tileRingStyle,
      diamondShape: tileDiamondShape,
      centerDiamondType: tileCenterDiamondType,
      color: tileColor,
      imageUrl: tileImageUrl,
      payload: JSON.stringify({
        id: entry?.product.Code,
        name: entry?.product.Name,
        price: entry?.product.price_at,
        ...(tileRingStyle && { ringStyle: tileRingStyle }),
        ...(tileDiamondShape && { diamondShape: tileDiamondShape }),
        ...(tileColor && { color: tileColor }),
        ...(tileCenterDiamondType && { centerDiamondType: tileCenterDiamondType }),
        imageUrl: tileImageUrl,
      }),
    };
    return (
      <ProductCard
        key={`${index}_${cardId}`}
        product={entry.product}
        uniqueProductId={cardId}
        isSelected={settingFilter.selectedProduct === entry.product.Code}
        isStuds={isStuds}
        showImageSlider={showImageSlider}
        selectedImage={favouriteImages[cardId]}
        swatches={swatches}
        swatchLoadingIds={favouriteSwatchLoadingIds}
        loadedImages={loadedImages}
        tracking={tracking}
        href={getProductHref(entry.product, image?.swatch)}
        onImageLoad={handleImageLoad}
        onSelect={() => handleProduct(entry.product.Code, entry.product, image?.swatch)}
        onSwatchClick={(key) => handleFavouriteSwatchClick(cardId, entry.product, key)}
        isFavourite={true}
        onToggleFavourite={() => toggleFavourite(entry.product, entry.color)}
      />
    );
  };

  if (settingFilter.isLoading) {
    return <Loader/>;
  }
  if (settingFilter.error) {
    return <div>error...</div>;
  }
  return (
    <div className={`${classes.main} rb-track-plp`} data-rb-page="setting-plp">
      <Header instanceData={instanceData} isStuds={isStuds}/>
      <div className={classes.root} ref={scrollRoot}>
        {isLargeTablet ? (
          <Filter
            isSetHeight={Object.keys(settingFilter.optionsData).length > 0}
            isShowFilter={true}
            isMobileLayout={isMobileLayout}
            isReset={isReset}
            handleRESETFilters={handleRESETFilters}
            isFavouritePanelOpen={isFavouritePanelOpen}
            setIsFavouritePanelOpen={setIsFavouritePanelOpen}
            favouriteProducts={hasFavourites ? favouriteProducts : []}
            favouritePanel={hasFavourites && (
              <div className={`${classes.grid_inner} ${classes.favouriteGrid}`}>
                {favouriteEntries.map(renderFavouriteCard)}
              </div>
            )}
          >
            <StartWithSettingFilter options={settingFilter.optionsData}/>
          </Filter>
        ) : (
          <div className={classes.filterWrp}>
            <div className={classes.filterWrpInner}>
              <StartWithSettingFilter options={settingFilter.optionsData}/>
            </div>
          </div>
        )}
        {/*<Filter isSetHeight={(isMobileLayout)?true:Object.keys(settingFilter.optionsData).length > 0}
                isShowFilter={true}
                isReset={(Object.keys(settingFilter.options).length) > (Object.keys(settingFilter.afterDiamondSelectedOptions).length > 0 ? 4: 2)}
                handleRESETFilters={handleRESETFilters}
                isMobileLayout={(isMobileLayout)}
        >
          <StartWithSettingFilter options={settingFilter.optionsData}/>
        </Filter>*/}
        <div className={classes.product_main}>
          <div className={classes.topbar}>
            <div className={classes.container}>
              <div className={classes.topbar_flex}>
                <div className={"flex gap-2 align-center items-center"}>
                  <span className={classes.topbar_count}>
                    {visibleCount} {isStuds ? 'Earring Studs' : 'Ring Settings'}
                  </span>
                  {isReset ? (
                    <div className={" flex gap-2 items-center"}>
                      <span className={classes.separator}> | </span>
                      <button
                        type="button"
                        className={classes.filterReset}
                        onClick={handleRESETFilters}
                      >
                        <span className="text-padding-top">Reset</span>
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {!isStuds && (
                  <nav className={classes.listingTabs} aria-label={"Product tabs"}>
                    {[
                      { label: 'All', isFavourite: false, count: settingFilter.products.length },
                      ...(hasFavourites
                        ? [ { label: 'Favorites', isFavourite: true, count: favouriteEntries.length } ]
                        : [])
                    ].map((tab) => (
                      <button
                        key={tab.label}
                        type="button"
                        aria-current={isFavouriteView === tab.isFavourite}
                        className={`${classes.listingTab} ${isFavouriteView === tab.isFavourite ? classes.listingTabActive : ''}`}
                        onClick={() => handleTabChange(tab.isFavourite)}
                      >
                        {tab.isFavourite && <Bookmark/>}
                        {tab.label} ({tab.count})
                      </button>
                    ))}
                  </nav>
                )}

                <div className={classes.topbar_sorting}>
                  {/*<Icon name={"Sort"} />*/}
                  <span className={classes.sortLabel}>Sort By:</span>
                  <div className={classes.dropdown} ref={dropdownRef}>
                    <div
                      className={classes.dropdown_header}
                      id={"sortby_dropdown_header"}
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (
                          event.target instanceof HTMLElement &&
                          event.key === "Enter"
                        ) {
                          handleDropdownToggle();
                        }
                      }}
                      onClick={() => handleDropdownToggle()}
                    >
                      {sortBy}
                      <span
                        className={`${classes.dropdownIcon} ${
                          isDropdownOpen ? classes.isActive : ""
                        }`}
                      >
                        <Icon name="hk-chevron-down_M"/>
                      </span>
                    </div>

                    <ul
                      id={"sortby_dropdown_options"}
                      className={`${classes.dropdown_options} ${
                        isDropdownOpen ? classes.isOpen : ""
                      }`}
                    >
                      {options.map((option) => (
                        <li
                          key={option}
                          tabIndex={isDropdownOpen ? 0 : -1}
                          onClick={() => handleOptionClick(option)}
                          // onKeyPress={() => handleOptionClick(option)}
                          onKeyDown={(event) => {
                            if (
                              event.target instanceof HTMLElement &&
                              event.key === "Enter"
                            ) {
                              handleOptionClick(option);
                            }
                            event.key === "Escape" && handleClickOutside(true);
                          }}
                          className={`${
                            sortBy === option ? classes.liselected : ""
                          }`}
                        >
                          <span className={classes.optionText}>{option}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* The request is for the All tab, so Favourites keeps its cards. */}
          {!isFavouriteView && (settingFilter.isProductLoading || settingFilter.isProductError) ? (
            <Loader/>
          ) : visibleCount > 0 ? (
            <section className={classes.grid_wrapper}>
              <div className={classes.grid_inner} id={"listing_inner_grid"}>
                {isFavouriteView
                  ? favouriteEntries.map(renderFavouriteCard)
                  : settingFilter.products.map(renderProductCard)}
              </div>
            </section>
          ) : (
            <div className={classes.noDataWrapper}>
              {isFavouriteView ? (
                <div className={classes.favouriteEmpty}>
                  You have not added any favorites yet.
                </div>
              ) : (
                <NoDataFound/>
              )}
            </div>
          )}
        </div>
        {/*onClick={scrollToTop}*/}
        <button
          onClick={handleScrollTopClick}
          className={`stickyButton ${showButton ? "active" : ""}`}
          aria-label={"Scroll to top"}
          onKeyDown={(eve) => {}}
        >
          <span className={"iconTop"}>
            <Icon name={"hk-arrow-up-forward"}/>
          </span>
        </button>
      </div>
      <StickyFooter instanceData={instanceData}/>
    </div>
  );
};
export default connector(StartWithSetting);
